import * as Yup from 'yup'
import { units, frequencies, unitStrengths } from '../util/medication'

export const MedicalBasicInfoSchema = Yup.object().shape({
  heightFt: Yup.number().label('Feet').required('Height in Feet cannot be empty'),
  heightIn: Yup.number()
    .label('Inches')
    .when('heightFt', {
      is: (value) => !value || value === 0,
      then: Yup.number().min(6, 'Height must be at least 6 inches'),
      otherwise: Yup.number(),
    })
    .required('Height in Inches cannot be empty'),
  weightLbs: Yup.number()
    .label('Weight in pounds')
    .min(1, 'Weight in pounds must be greater than 1 lbs')
    .max(1000, 'Weight in pounds must be less than or equal to 1000 lbs')
    .required('Weight in pounds cannot be empty'),
})

const drinkFrequency = ['Sometimes', 'Often', 'Rarely']
export const LifestyleSchema = (required = true) => {
  let validation = Yup.boolean().nullable()
  if (required) {
    validation = validation.required()
  }
  return Yup.object().shape({
    smoke: validation.label("'Do you smoke/use tobacco?'"),
    vape: validation.label("'Do you vape?'"),
    drink: validation.label("'Do you drink alcohol?'"),
    drinkFrequency: Yup.string()
      .label("'How often do you drink?'")
      .when('drink', {
        is: (value) => value === true,
        then: Yup.string().required().oneOf(drinkFrequency),
        otherwise: Yup.string()
          .oneOf(drinkFrequency.concat([null]))
          .nullable()
          .strip(),
      }),
    sexuallyActive: validation.label("'Are you sexually active?'"),
  })
}

export const ConditionSchema = Yup.object().shape({
  condition: Yup.string().required(),
  conditionId: Yup.string().required(),
  id: Yup.string(),
  name: Yup.string().required(),
  value: Yup.boolean(),
})

export const OtherConditionSchema = Yup.object().shape({
  id: Yup.string().notRequired(),
  conditionId: Yup.string().notRequired(),
  value: Yup.string().required(),
})

export const MedicationSchema = Yup.object().shape({
  id: Yup.string().notRequired(),
  name: Yup.string().label('Medication Name').min(3).required(),
  strength: Yup.number().label('Strength').moreThan(0, 'Strength must be a positive number').required(),
  unitStrength: Yup.string().label('Unit of Strength').oneOf(unitStrengths).required(),
  unit: Yup.string().label('Unit').oneOf(units).required(),
  dosage: Yup.number().label('Dosage').moreThan(0, 'Dosage must be a positive number').required(),
  frequency: Yup.string().label('Frequency').oneOf(frequencies).required(),
  active: Yup.boolean().label('Actively taking medication').required(),
})

const MedicalHistorySchema = Yup.object().shape({
  memberId: Yup.string().required(),
  heightFt: Yup.number(),
  heightIn: Yup.number(),
  weightLbs: Yup.number(),
  // bpSystolic: Yup.number()
  //   .notRequired()
  //   .default(null),
  // bpDiastolic: Yup.number()
  //   .notRequired()
  //   .default(null),
  lifestyle: LifestyleSchema(false),
  conditions: Yup.array().of(ConditionSchema).default([]),
  other: Yup.array().of(OtherConditionSchema).default([]),
  medications: Yup.array().of(MedicationSchema).default([]),
  allergiesCompleted: Yup.boolean().default(false),
  medicationsCompleted: Yup.boolean().default(false),
  conditionsCompleted: Yup.boolean().default(false),
  familyHistoryCompleted: Yup.boolean().default(false),
  primaryCareCompleted: Yup.boolean().default(false),
})

export default MedicalHistorySchema
